import PropTypes from "prop-types";
import React from "react";
import { Nav } from "react-bootstrap";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { slugify } from "../../utils/utils.js";
import "./QuickMenu.scss";

const messages = {
  header: {
    id: "components.Menu.QuickMenu.header",
    defaultMessage: "Jump to",
  },
  arriVideo: {
    id: "components.Menu.QuickMenu.arriVideo",
    defaultMessage: "ArriVideo",
  },
  urlEntry: {
    id: "components.Menu.QuickMenu.urlEntry",
    defaultMessage: "URL Module",
  },
  establishments: {
    id: "components.Menu.QuickMenu.establishments",
    defaultMessage: "Establishments",
  },
  tabletRegistration: {
    id: "components.Menu.QuickMenu.tabletRegistration",
    defaultMessage: "Tablet registration",
  },
  softwarePackage: {
    id: "components.Menu.QuickMenu.softwarePackage",
    defaultMessage: "ICT News - Applications",
  },
  notifications: {
    id: "components.Menu.QuickMenu.notifications",
    defaultMessage: "ICT News - Messages",
  },
  malfunctions: {
    id: "components.Menu.QuickMenu.malfunctions",
    defaultMessage: "Malfunctions",
  },
  usersNotifications: {
    id: "components.Menu.QuickMenu.usersNotifications",
    defaultMessage: "Users Notifications",
  },
  signalImages: {
    id: "components.Menu.QuickMenu.signalImages",
    defaultMessage: "Signal images",
  },
  settings: {
    id: "components.Menu.QuickMenu.settings",
    defaultMessage: "Settings",
  },
};

const QuickMenu = ({ menuItems }) => {
  const intl = useIntl();

  const renderMenuItem = (item) => {
    const key = slugify(item.name);
    const label = intl.formatMessage(
      messages[item.name] || { defaultMessage: item.name },
    );

    const menuLink = /^(http|https):/.test(item.link) ? (
      <Nav.Link
        key={key}
        href={item.link}
        target={item.target || "_self"}
        className="nav-item"
      >
        <span>{item.icon}</span>
        {label}
      </Nav.Link>
    ) : (
      <Nav.Link as={Link} to={item.link} key={key} className="nav-item">
        <span>{item.icon}</span>
        {label}
      </Nav.Link>
    );

    return menuLink;
  };

  return (
    <Nav variant="tabs" className="flex-column quick-links">
      <div className="navbar-header border-white">
        <h4>{intl.formatMessage(messages.header)}</h4>
      </div>
      {menuItems && menuItems.map(renderMenuItem)}
    </Nav>
  );
};

QuickMenu.propTypes = {
  menuItems: PropTypes.array.isRequired,
};

export default QuickMenu;
